import { Link } from 'react-router-dom';
import { DashboardSidebar } from '@/layouts/dashboard';
import { FiChevronLeft } from 'react-icons/fi';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

export function BulletinBoardsCreateSidedar() {
  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to="/banners">
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>Banner informativo</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>
    </DashboardSidebar>
  );
}
